import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Box, Typography } from '@mui/material';
import moment from 'moment-timezone';
import { ReactNode } from 'react';

// Shared overrides that make the react-datepicker popup match the legacy
// react-dates look: white header, gridded day cells, blank overflow days.
export const axleDatePickerPopupSx = {
    '& .react-datepicker__header': {
        backgroundColor: '#fff',
        borderBottom: 'none',
    },
    '& .react-datepicker__day-name, & .react-datepicker__day': {
        border: '1px solid',
        borderColor: 'grey.200',
        borderRadius: 0,
        margin: 0,
        width: '2.75rem',
        lineHeight: '2.75rem',
    },
    '& .react-datepicker__day-name': {
        border: 'none',
        color: 'text.secondary',
        lineHeight: '1.5rem',
    },
    '& .react-datepicker__day--outside-month': {
        visibility: 'hidden',
    },
} as const;

const NavButton = ({ onClick, children }: { onClick: () => void; children: ReactNode }) => (
    <Box
        component='button'
        onClick={onClick}
        sx={{
            background: '#fff',
            border: '1px solid',
            borderColor: 'grey.300',
            borderRadius: '4px',
            cursor: 'pointer',
            color: 'text.secondary',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 28,
            height: 28,
            p: 0,
            '&:hover': { color: 'text.primary', borderColor: 'grey.500' },
        }}
    >
        {children}
    </Box>
);

export const AxleDatePickerHeader = ({
    date,
    decreaseMonth,
    increaseMonth,
}: {
    date: Date;
    decreaseMonth: () => void;
    increaseMonth: () => void;
}) => (
    <Box display='flex' justifyContent='space-between' alignItems='center' px={1} pb={0.5}>
        <NavButton onClick={decreaseMonth}>
            <ArrowBackIcon sx={{ fontSize: 16 }} />
        </NavButton>
        <Typography variant='subtitle2'>{moment(date).format('MMMM YYYY')}</Typography>
        <NavButton onClick={increaseMonth}>
            <ArrowForwardIcon sx={{ fontSize: 16 }} />
        </NavButton>
    </Box>
);
